import React, { useState, useContext } from 'react';
import {
  TableContainer,
  Grid,
  Table,
  TableHead,
  TableRow,
  Checkbox,
  TableBody,
  TablePagination,
  makeStyles,
  lighten,
  Toolbar,
  Tooltip,
  Button,
  Fade,
} from '@material-ui/core';
import {
  Create as CreateIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import UPaper from 'components/UPaper';
import UTableHeading from 'components/UTableHead';
import MESSAGES from 'constants/messages';
import * as CertificadoApi from 'api/certificado';
import { useSnackbar } from 'notistack';
import CertificadoContext from '../Context/list';
import Row from './Row';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
}));

const EnhancedTableToolbar = ({ numSelected, selected }) => {
  const classes = useToolbarStyles();
  const { enqueueSnackbar } = useSnackbar();

  const assinarDocumento = async () => {
    /*  const promises = selected.map((id) => CertificadoApi.assinar(id)); */
    CertificadoApi.assinar(selected).then((dados) => {
      if (dados.status === 200) {
        enqueueSnackbar('Certificado iniciado processo de assinatura', { variant: 'success' });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        enqueueSnackbar('Documento ja se encontra em processo de assinatura', { variant: 'warning' });
      }
    });
  };

  if (numSelected > 0) {
    return (
      <Fade in={numSelected > 0} out={numSelected === 0}>
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          <Tooltip title="Iniciar">
            <Button
              variant="contained"
              color="primary"
              type="button"
              onClick={assinarDocumento}
              startIcon={<CreateIcon />}
            >
              Assinar

            </Button>
          </Tooltip>
        </Toolbar>
      </Fade>
    );
  }
  return null;
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
};

const useListStyles = makeStyles({
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
  },
});

function List() {
  const classes = useListStyles();
  const [selectedItems, setSelectedItems] = useState([]);
  const { data } = useContext(CertificadoContext);
  const allItemsSelected = selectedItems && selectedItems.length > 0 && selectedItems.length === data.length;

  const handleChangeSelection = (event, id) => {
    const selectedIndex = selectedItems.indexOf(id);

    let newSelection = [];
    if (selectedIndex === -1) {
      newSelection = [...selectedItems, id];
    } else if (selectedIndex === 0) {
      newSelection = [...selectedItems.slice(1)];
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelection = [...selectedItems.slice(0, -1)];
    } else if (selectedIndex > 0) {
      newSelection = [
        ...selectedItems.slice(0, selectedIndex),
        ...selectedItems.slice(selectedItems + 1),
      ];
    }

    setSelectedItems(newSelection);
  };

  const onSelectAllClick = (event) => {
    if (event.target.checked) {
      const items = data.map((i) => i.id);
      setSelectedItems(items);
      return;
    }
    setSelectedItems([]);
  };
  return (
    <TableContainer component={UPaper} gutterTop>
      <Grid
        container
        direction="column"
      >
        <Grid item lg={12} className={classes.tableWrapper}>
          <EnhancedTableToolbar numSelected={selectedItems.length} selected={selectedItems} />
          <Table aria-label="tabela de resultados">
            <TableHead>
              <TableRow>
                <UTableHeading padding="checkbox">
                  <Checkbox
                    inputProps={{ 'aria-label': 'select all' }}
                    checked={allItemsSelected}
                    onChange={onSelectAllClick}
                  />
                </UTableHeading>
                <UTableHeading>Código Consulta</UTableHeading>
                <UTableHeading>Certificando</UTableHeading>
                <UTableHeading>Marca</UTableHeading>
                <UTableHeading>Matricula</UTableHeading>
                <UTableHeading>CPF</UTableHeading>
                <UTableHeading>Tipo Curso</UTableHeading>
                <UTableHeading>Curso</UTableHeading>
                <UTableHeading>Data da Conclusão</UTableHeading>
                <UTableHeading>Responsáveis</UTableHeading>
                <UTableHeading>Status</UTableHeading>
                <UTableHeading />
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <Row
                  key={row.id}
                  row={row}
                  selectedItems={selectedItems}
                  handleChangeSelection={handleChangeSelection}
                />
              ))}
            </TableBody>
            <TablePagination
              colSpan={11}
              count={Array.isArray(data) ? data.length : 0}
              rowsPerPage={10}
              labelRowsPerPage={MESSAGES.mostrarLinhas}
              labelDisplayedRows={({ from, to, count }) => `${from} a ${to} de ${Number(count)}`}
              page={0}
              backIconButtonProps={{
                'aria-label': 'Pagina Anterior',
              }}
              nextIconButtonProps={{
                'aria-label': 'Próxima Página',
              }}
            />
          </Table>

        </Grid>
      </Grid>
    </TableContainer>
  );
}

export default List;
